import { useState } from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, ListTodo, KanbanSquare, MoreHorizontal, Map, Activity, BarChart3, Users, Shield, LogOut, UserCircle } from "lucide-react";
import { NotificationBell } from "./NotificationBell";

export const MobileNav = ({ user, onOpenProfile, onLogout }) => {
  const [more, setMore] = useState(false);
  const item = ({ isActive }) =>
    `flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium transition-colors ${isActive ? "text-primary" : "text-zinc-400"}`;
  const moreLinks = [
    { to: "/roadmap", icon: Map, label: "Roadmap", id: "roadmap" },
    { to: "/activity", icon: Activity, label: "Actividad", id: "actividad" },
    { to: "/reports", icon: BarChart3, label: "Informes", id: "informes" },
    { to: "/team", icon: Users, label: "Equipo", id: "equipo" },
    ...(user?.role === "admin" ? [{ to: "/admin", icon: Shield, label: "Admin", id: "admin" }] : []),
  ];
  return (
    <>
      <nav data-testid="mobile-nav" className="md:hidden fixed bottom-0 inset-x-0 z-40 h-16 glass border-t border-white/10 grid grid-cols-5">
        <NavLink to="/" end className={item} data-testid="mnav-panel"><LayoutDashboard className="h-5 w-5" />Panel</NavLink>
        <NavLink to="/my-tasks" className={item} data-testid="mnav-mytasks"><ListTodo className="h-5 w-5" />Tareas</NavLink>
        <NavLink to="/boards" className={item} data-testid="mnav-boards"><KanbanSquare className="h-5 w-5" />Tableros</NavLink>
        <NotificationBell mobile />
        <button onClick={() => setMore(true)} data-testid="mnav-more"
          className="flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium text-zinc-400">
          <MoreHorizontal className="h-5 w-5" />Más
        </button>
      </nav>
      {more && (
        <div className="md:hidden fixed inset-0 z-50 bg-black/60 backdrop-blur-sm" onClick={() => setMore(false)} data-testid="mobile-more-sheet">
          <div className="absolute bottom-0 inset-x-0 bg-[#121214] border-t border-white/10 rounded-t-2xl p-4 pb-8 animate-fade-up" onClick={(e) => e.stopPropagation()}>
            <div className="h-1 w-10 bg-white/20 rounded-full mx-auto mb-4" />
            <div className="grid grid-cols-3 gap-2">
              {moreLinks.map((l) => (
                <NavLink key={l.to} to={l.to} onClick={() => setMore(false)} data-testid={`mnav-${l.id}`}
                  className={({ isActive }) =>
                    `flex flex-col items-center gap-1.5 rounded-xl py-3.5 text-xs font-medium border transition-colors ${
                      isActive ? "border-primary/40 bg-primary/10 text-primary" : "border-white/10 bg-white/[0.03] text-zinc-300"
                    }`}>
                  <l.icon className="h-5 w-5" /> {l.label}
                </NavLink>
              ))}
              <button onClick={() => { setMore(false); onOpenProfile(); }} data-testid="mnav-profile"
                className="flex flex-col items-center gap-1.5 rounded-xl py-3.5 text-xs font-medium border border-white/10 bg-white/[0.03] text-zinc-300">
                <UserCircle className="h-5 w-5" /> Perfil
              </button>
              <button onClick={onLogout} data-testid="mnav-logout"
                className="flex flex-col items-center gap-1.5 rounded-xl py-3.5 text-xs font-medium border border-red-500/20 bg-red-500/5 text-red-400">
                <LogOut className="h-5 w-5" /> Salir
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
